import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Navigation from "../Navigations/MainNavigation";
import RulesNav from "./Nav";
import Footer from "../Footer";

import styled from "styled-components";
const ContainerMain = styled.div`
  width: 100%;
`;
const Container = styled.div`
  width: 80%;
  height: 800px;
  padding-top: 100px;
  margin-left: 10%;
  padding-top: 100px;
`;
const Nav = styled.div`
  width: 20%;
  height: 100%;
  float: left;
`;

const MainContent = styled.div`
  width: 78%;
  height: 100%;
  float: right;
`;
const Title = styled.h1`
  font-weight: 600;
  font-size: 2em;
  margin: 0;
  padding: 0;
`;
const TextBlock = styled.p`
  color: #636161;
`;
const SubTitle = styled.h2`
  font-weight: 600;
  font-size: 1.2em;
  margin: 30px 0 10px 0;
  padding: 0;
`;
const ListItem = styled.li`
  color: #636161;
  margin: 0 0 10px 0;
`;
function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <ContainerMain>
      <Navigation />
      <Container>
        <Nav>
          <RulesNav />
        </Nav>
        <MainContent>
          <Title>About Maplun</Title>
          <TextBlock>
            Maplun.com is a PhysiTaL (Physical + Digital + Local) market where
            shops or sellers must exist physically and locally. It is designed
            for some proven product and service categories, where sellers/shops
            and customers directly connect with one another locally. Building
            ‘trustworthy relationship’ between the sellers and customers is of
            our ‘number one priority’ throughout the business design, strategy
            and process. Maplun - as a name: ‘Map’ denotes a geographic map and
            ‘Lun’ stands for logical unit number.
          </TextBlock>
          <SubTitle>Maplun.com – A Quick Look:</SubTitle>
          <ListItem>PhysiTaL Market (Physical + Digital + Local)</ListItem>
          <ListItem>
            4 T Model: Trust in Trade, Transaction & Technology
          </ListItem>
          <ListItem>Online Shopping From Nearby Shops</ListItem>
          <ListItem>Shops Near Me</ListItem>
          <TextBlock>
            Not by commitment only, we systematically deploy the ‘trust’ into
            the trade, transaction and technology. Maplun.com runs on the
            “PhysiTaL 4 T Model” originated and configured by its parent
            company. 4T Model: Trust in Trade, Transaction and Technology. It
            aims to integrate the Cyber Physical System (CPS) for the next level
            user experience.
          </TextBlock>
          <TextBlock>
            Customers don’t want to buy from air; don’t want to pay to air. In
            the existing ecommerce model, customers get bluffed by untraced
            virtual sellers in many cases. As a platform, Maplun.com connects
            nearby, and physical shops or sellers with customers. To get stick
            to the trust, we don’t allow any unseen virtual seller to
            Maplun.com.
          </TextBlock>
          <TextBlock>
            We are neither a trader nor a manufacturer of products. We normally
            don’t sell or have interaction in any sale, unless declares to sell
            any product. Therefore, Maplun doesn't enter into the profit or loss
            of vendors or customers in transaction.
          </TextBlock>
          <TextBlock>
            Innovatus, an intelligent technology company, sponsored Maplun.com -
            was established in 2012. This parent company delved into diverse
            projects across industries by integrating innovations with business,
            technology and IT for bringing superior outcomes. We build on the
            commercially viable ‘artistic science’ and ‘scientific art’ to ease
            people’s daily affairs. At the core of corporate strategy, we design
            systems to simplify working process of man, machine, material and
            their management. We have already performed significant number of
            successful and innovative projects in several industries.
          </TextBlock>
          <SubTitle>-Trust & Respect</SubTitle>
          <SubTitle>Maplun.com</SubTitle>
        </MainContent>
      </Container>
      <Footer />
    </ContainerMain>
  );
}

export default About;
